import {Component, Input} from '@angular/core';

@Component({
  selector: 'crm-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  @Input() sidebarOpen = true;
  currentYear: number = new Date().getFullYear();
}
